import { render, staticRenderFns } from "./TitleDetailLink.vue?vue&type=template&id=2003b1a1"
import script from "./TitleDetailLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleDetailLink.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleDetailLink.vue?vue&type=style&index=0&id=2003b1a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports